import { render, staticRenderFns } from "./ReadAccusesIndicators.vue?vue&type=template&id=d08b81cc"
import script from "./ReadAccusesIndicators.vue?vue&type=script&lang=js"
export * from "./ReadAccusesIndicators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports